export const formatValidationMessage = (prefix: string, messages: Record<string, string>) => {
  let message;

  if (messages && Object.keys(messages).length > 0) {
    message = [prefix, Object.values(messages).join('\n')].join(' ');
  }

  return message;
};
